<template>
  <div class="map" ref="map">
    <div class="map__container">
      <div id="map--nest" class="jvmap-smart"></div>
    </div>
    <template v-if="window.width >= 768">
      <ul class="map__nav">
        <li
          @click="handleChangeList(0, defaultGroupName)"
          :class="{ __active: selectedRegionNavClass == 0 }"
        >
          {{ defaultGroupName }}
        </li>
        <template v-for="(grupa, index) in grupy">
          <li
            @click="handleChangeList(grupa.id, grupa.name)"
            :class="{ __active: selectedRegionNavClass == grupa.id }"
            :key="index"
          >
            {{ grupa.name }}
          </li>
        </template>
      </ul>
    </template>
    <template v-if="window.width < 768">
      <div class="map__region-select">
        <div class="font-m mb-6">Wybierz region:</div>
        <div class="form-control-yellow">
          <a-config-provider :locale="pl_PL">
            <a-select
              :getPopupContainer="getPopupContainer"
              class="w-100"
              ref="select"
              v-model="selectedGroupName"
              @change="handleChange"
            >
              <a-select-option value="0">
                {{ defaultGroupName }}
              </a-select-option>
              <template v-for="(grupa, index) in grupy">
                <a-select-option :key="index" :value="grupa.id">
                  {{ grupa.name }}
                </a-select-option>
              </template>
            </a-select>
          </a-config-provider>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import jQuery from "jquery";
import moment from "moment";
import pl_PL from "ant-design-vue/lib/locale-provider/pl_PL";
import "moment/locale/pl";
moment.locale("pl");

const { $, jquery } = require("jquery");
global.$ = $;
global.jQuery = jquery;

export default {
  props: {
    portale: [Array, Object],
    grupy: [Array, Object],
    regionAbbr: Array,
  },
  data: () => ({
    pl_PL,
    varDomBilArray: {
      jp: "bilety-lotnicze.Japonia.biz.pl",
      re: "bilety-lotnicze.Reunion.pl",
      mg: "bilety-lotnicze.Madagaskar.info.pl",
      np: "bilety-lotnicze.Nepal.info.pl",
      vn: "bilety-lotnicze.Wietnam.info.pl",
    },
    varDomArray: {
      mj: "portugalia.com.pl",
      ay: "portugalia.com.pl",
      hr: "chorwacja.pl",
      bg: "bulgaria.pl",
      at: "austria.pl",
      me: "czarnogora.pl",
      cz: "czechy.pl",
      fr: "francja.pl",
      gr: "grecja.com.pl",
      es: "hiszpania.com.pl",
      cu: "karaiby.pl",
      mx: "meksyk.com.pl",
      si: "slowenia.info.pl",
      th: "tajlandia.com.pl",
      tr: "turcja.com.pl",
      hu: "wegry.biz.pl",
      it: "wlochy.pl",
      fu: "wyspykanaryjskie.pl",
      ma: "maroko.com.pl",
      mi: "majorka.com.pl",
      eg: "egipt.info.pl",
      tn: "tunezja.com.pl",
      ro: "rumunia.info.pl",
      cy: "cypr.net.pl",
      pt: "portugalia.com.pl",
      mt: "malta-gozo.pl",
      sk: "slowacja.com.pl",
      mu: "mauritius.pl",
      my: "malezja.info.pl",
      tz: "tanzania.pl",
      ae: "emiratyarabskie.pl",
      pf: "polinezja.pl",
      sc: "seszele.com.pl",
      mv: "malediwy.com.pl",
      ha: "hawaje.com.pl",
      ke: "kenia.info.pl",
      lk: "srilanka.com.pl",
      bl: "bali.pl",
      il: "izrael.pl",
      br: "brazylia.com.pl",
      us: "stanyzjednoczone.pl",
      ch: "szwajcaria.com.pl",
      cn: "chiny.com.pl",
      in: "indie.com.pl",
      jo: "jordania.info.pl",
      pe: "peru.info.pl",
      de: "niemcy.com.pl",
      ca: "kanada.pl",
      ve: "wenezuela.info.pl",
      ie: "irlandia.info.pl",
      ru: "rosja.pl",
      gb: "wielkabrytania.com.pl",
      za: "rpa.pl",
      cv: "wyspyzielonegoprzyladka.pl",
      gm: "gambia.com.pl",
      dk: "dania.info.pl",
      ar: "argentyna.info.pl",
      nl: "holandia.info.pl",
      fi: "finlandia.info.pl",
      no: "norwegia.info.pl",
      is: "islandia.info.pl",
      be: "belgia.info.pl",
      lt: "litwa.info.pl",
      al: "albania.info.pl",
      bz: "belize.com.pl",
      ba: "bosnia.pl",
      co: "kolumbia.net.pl",
      rs: "serbia.pl",
      cl: "chile.info.pl",
      ir: "iran.net.pl",
      na: "namibia.pl",
      se: "szwecja.info.pl",
      lv: "lotwa.info.pl",
      ee: "estonia.info.pl",
      mk: "macedonia.net.pl",
      pl: "polska.travelone.pl",
    },
    selectedRegionNavClass: 0,
    defaultGroupName: "Wszystkie",
    selectedGroupName: "Wszystkie",
    window: {
      width: 0,
      height: 0,
    },
  }),
  methods: {
    handleChangeList(value, name) {
      this.selectedGroupName = name;
      this.handleChange(value);
    },
    handleChange(value) {
      this.selectedRegionNavClass = value;
      this.$root.$emit("update:groupIdx", value);
      this.mapUpdate(value);
    },
    getPopupContainer(trigger) {
      return trigger.parentElement;
    },
    drawMap() {
      let varDomBilArray = this.varDomBilArray;
      let varDomArray = this.varDomArray;
      let vdoma = {};
      let values = vdoma;
      let mapTopPos =
        this.$refs["map"].getBoundingClientRect().top + window.scrollY;

      jQuery.each(varDomArray, function (key, value) {
        var domnazwa = key.substr(0, 2);
        jQuery("body").on("click", "#" + domnazwa, function () {
          jQuery("[data-code!='']").removeClass("__region-selected");
          jQuery("html, body").animate({ scrollTop: mapTopPos - 16 }, 200);
          jQuery("[data-code='" + domnazwa + "']").addClass(
            "__region-selected"
          );
        });
      });
      jQuery.each(varDomArray, function (key, value) {
        vdoma[key] = "#617a95";
      });
      jQuery.each(varDomBilArray, function (key, value) {
        vdoma[key] = "#617a95";
      });
      jQuery("#map--nest").vectorMap({
        map: "world_mill",
        backgroundColor: "transparent",
        zoomOnScroll: false,
        regionStyle: {
          initial: {
            fill: "#7a91aa",
            "fill-opacity": 1,
          },
          hover: {
            cursor: "default",
            "fill-opacity": 1,
          },
        },
        onRegionClick: function (event, code) {
          var linkda;
          if (
            typeof varDomArray[code] != "undefined" &&
            varDomArray[code] != ""
          ) {
            linkda = varDomArray[code];
            window.location = "http://www." + linkda;
          } else if (
            typeof varDomBilArray[code] != "undefined" &&
            varDomBilArray[code] != ""
          ) {
            linkda = varDomBilArray[code];
            window.location = "http://www." + linkda;
          }
        },
        onRegionOver: function (event, code) {
          if (
            (typeof varDomArray[code] != "undefined" &&
              varDomArray[code] != "") ||
            (typeof varDomBilArray[code] != "undefined" &&
              varDomBilArray[code] != "")
          ) {
            jQuery(this)
              .find("path[data-code=" + code)
              .addClass("__region-hover");
          }
        },
        onRegionOut: function (event, code) {
          if (
            (typeof varDomArray[code] != "undefined" &&
              varDomArray[code] != "") ||
            (typeof varDomBilArray[code] != "undefined" &&
              varDomBilArray[code] != "")
          ) {
            jQuery(this)
              .find("path[data-code=" + code)
              .removeClass("__region-hover");
          }
        },
        series: {
          regions: [
            {
              values,
            },
          ],
        },
      });
    },
    mapUpdate(dataId) {
      var zParams;
      if (dataId == "0") {
        zParams = {
          scale: 1,
          x: 0.5,
          y: 0.5,
        };
      } else if (dataId == "1") {
        zParams = {
          scale: 3.8,
          x: 0.51,
          y: 0.3,
        };
      } else if (dataId == "2") {
        zParams = {
          scale: 4.2,
          x: 0.6,
          y: 0.46,
        };
      } else if (dataId == "3") {
        zParams = {
          scale: 4.2,
          x: 0.7,
          y: 0.52,
        };
      } else if (dataId == "4") {
        zParams = {
          scale: 2.8,
          x: 0.72,
          y: 0.52,
        };
      } else if (dataId == "5") {
        zParams = {
          scale: 2.2,
          x: 1.0,
          y: 1.0,
        };
      } else if (dataId == "6") {
        zParams = {
          scale: 4.2,
          x: 0.52,
          y: 0.5,
        };
      } else if (dataId == "7") {
        zParams = {
          scale: 4.2,
          x: 0.56,
          y: 0.69,
        };
      } else if (dataId == "8") {
        zParams = {
          scale: 4,
          x: 0.56,
          y: 0.7,
        };
      } else if (dataId == "9") {
        zParams = {
          scale: 3,
          x: 0.1,
          y: 0.46,
        };
      } else if (dataId == "10") {
        zParams = {
          scale: 2.2,
          x: 0.26,
          y: 0.76,
        };
      } else if (dataId == "11") {
        zParams = {
          scale: 1.8,
          x: 0,
          y: 0.56,
        };
      }
      jQuery("#map--nest").vectorMap("get", "mapObject").setFocus(zParams);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
  mounted() {
    require("jvectormap");
    require("../../lib/jquery-jvectormap-world-mill.js");
    this.drawMap();
  },
  created() {
    window.addEventListener("resize", this.handleResize, { passive: true });
    this.handleResize();
  },
};
</script>

<style lang="scss" scoped>
@import "@/components/T1PortaleTurystyczne/T1MapStyles";
</style>

<style>
.jvectormap-tip {
  box-shadow: 4px 4px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #292929;
  border-radius: 3px;
  color: #fff;
  display: none;
  font-size: 14px;
  padding: 4px 8px;
  position: absolute;
}
</style>
